import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {BI_ORIGIN} from '../../components/thankYouPage/constants';
import {PaymentsApi} from '@wix/wixstores-client-storefront-sdk/dist/es/src/apis/PaymentsApi/PaymentsApi';
import {PaymentMethod} from '../../types/app.types';

export class PaymentsService {
  private readonly paymentsApi: PaymentsApi;

  constructor({siteStore}: {siteStore: SiteStore}) {
    this.paymentsApi = new PaymentsApi({siteStore, origin: BI_ORIGIN});
  }

  public async fetchOfflineInstruction(): Promise<string> {
    const payments = await this.paymentsApi.fetchPayments({paymentMethod: PaymentMethod.Offline});
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    return payments.offlineInstruction.offlineInstruction;
  }
}
